/* ============================================================================
 * 后端连通性与求解内核状态
 * B-01：顶栏标「CP-SAT」还是「演示内核」由这里的真实自检决定，不写死。
 * ========================================================================== */
import { create } from 'zustand';
import { health, type HealthInfo } from '@/lib/api';

interface BackendState {
  info: HealthInfo;
  checked: boolean;
  check: () => Promise<void>;
}

export const useBackend = create<BackendState>((set) => ({
  info: { status: 'offline', kernel: 'demo' },
  checked: false,
  check: async () => {
    const info = await health();
    set({ info, checked: true });
  },
}));
